import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import LoginForm from "../../components/signIn/loginForm";
import { signIn, getLastPath } from "../../modules/userSession";

function SignIn() {
  const auth = useAuth();

  const navigate = useNavigate();
  useEffect(() => {
    auth.isAuthenticated && navigate(getLastPath());
  }, [auth.isAuthenticated, navigate]);

  const [loading, setLoading] = useState();
  useEffect(() => {
    if (!auth.isAuthenticated) {
      setLoading(true);
      auth
        .signinRedirect()
        .then(() => setLoading())
        .catch(() => setLoading());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.isAuthenticated]);

  const handleSignIn = useCallback((credentials) => {
    setLoading(true);
    signIn(credentials).then((result) => {
      !result.success && setLoading();
    });
  }, []);

  return <LoginForm loading={loading} onFinish={handleSignIn} />;
}

export default SignIn;
